import { createContext, useContext } from "react";

export interface UseWindow {
  window: typeof window;
}

export const WindowContext = createContext<UseWindow>({ window });

export const useWindow = () => useContext(WindowContext);
